import React from 'react';
import "./popupXLarge.css"
import "./popup.css"
import "./popupMedium.css"
import "./popupSmall.css" 
import "./popupXSmall.css"
import {RxCross1} from "react-icons/rx";

const PopupCatalog = (props) => {
  return (props.trigger) ? (
    <>
        <div className='popup' onClick={() => props.setTrigger(false)}/>
        <div className='popup-inner catalog'>
            <button className='catalog-close-btn' >
                <RxCross1 onClick={() => props.setTrigger(false)} />
            </button>
            <div className='catalog-intro'>
              <h4 className='catalog-title'>{props.title}</h4>
            </div>
            
              {
                props?.category && props?.category?.map((item, index) => {
                  return (
                    <div className='catalog-card' key={index}>
                      <div className='catalog-card-left'>
                        <img src={item?.image}  loading="lazy" alt="project visual"/>
                      </div>
                      <div className='catalog-card-right'>
                        <h5>{item?.name}</h5>

                        <div className={item?.nothing ? 'hidden absolute'  : 'slider-tech' }>
                                
                            {item?.tech?.map((techLogo,index) => {
                                    return <img key={index} src={techLogo?.logo} title={techLogo?.title} alt="Technology"/>
                                })}
                        </div>

                        <p>{item?.desc}</p> 

                        <div className={item?.nothing ? 'comingSoon-wrapper' : 'hidden absolute' }>
                            <p className='comingSoon' >
                                Coming soon !
                            </p>
                        </div>

                        <button onClick={() => props.onClick(index)} className={item?.nothing ? 'hidden absolute'  : 'main-button popup-btn catalog-btn' }>Learn more</button>
                      </div>
                    </div>
                  )
                })
              }
        </div>
      </>
  ) : "";
}

export default PopupCatalog